// extracted by mini-css-extract-plugin
export default {"wrapper":"CRMBannerPage_wrapper__tPtWE"};